module.exports = __webpack_public_path__ + "img/ic_nav_close.d10a6fa8.svg";